import type { QueryClient } from '@tanstack/react-query';

const jobViews = new Set(['job', 'job-workspace', 'job-activity', 'jobFinancialSummary', 'job-profit']);
const jobReports = new Set(['jobs', 'profit-desk', 'cash-desk']);

/** Refresh mounted views after a job edit; inactive tabs refresh when opened. */
export function refreshJobViews(queryClient: QueryClient, jobId: string | number) {
  const id = String(jobId);
  return queryClient.invalidateQueries({
    predicate: ({ queryKey }) => {
      const [resource, scope] = queryKey;
      if (jobReports.has(String(resource))) return true;
      if (jobViews.has(String(resource))) return String(scope) === id;
      // Preview/settings caches are scoped by user and job, not just the job ID.
      return (resource === 'commission-preview' || resource === 'commission-structure')
        && typeof scope === 'string' && scope.endsWith(`:/api/jobs/${id}`);
    },
  });
}
